(() => {
  const scriptElement = document.currentScript;
  const clarityId = scriptElement?.dataset.clarityId;
  const gtmId = scriptElement?.dataset.gtmId;
  let started = false;

  const appendScriptOnce = (src) => {
    if (document.querySelector(`script[src="${src}"]`)) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  };

  const startAnalytics = () => {
    if (started) return;
    started = true;

    if (clarityId) {
      window.clarity = window.clarity || function clarity() {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
      appendScriptOnce(`https://www.clarity.ms/tag/${encodeURIComponent(clarityId)}`);
    }

    if (gtmId) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });
      appendScriptOnce(`https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`);
    }
  };

  const scheduleAnalytics = () => {
    window.setTimeout(() => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(startAnalytics, { timeout: 2000 });
      } else {
        startAnalytics();
      }
    }, 6000);
  };

  if (document.readyState === 'complete') {
    scheduleAnalytics();
  } else {
    window.addEventListener('load', scheduleAnalytics, { once: true });
  }
})();
